<template>
    <v-menu
        content-class="sub-list"
        offset-y
        bottom
        left
        z-index="3011"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                right
                :ripple=false
                class="align-self-center"
                v-bind="attrs"
                v-on="on"
            >
                <v-icon right class="hotspot-btn">
                    mdi-chevron-down
                </v-icon>
            </v-btn>
        </template>

        <v-list class="py-0">
            <v-list-item
                v-for="(menuItem, index) of itemList"
                :key="index"
                link
                class="subItem px-1"
                :class="{ 'active': menuItem.active }"
                active-class="active"
                @click.prevent="selectItem(navigationItem, menuItem)"
            >
                <v-list-item-icon class="pt-2 mr-2 my-0">
                    <v-img
                        :class="{ 'ml-3': $vuetify.breakpoint.smAndUp && $vuetify.breakpoint.width > 750 }"
                        :src="navigationItem.preview || hotspotImg"
                        max-width="35"
                        height="35"
                        contain
                        rounded
                        class="white rounded-circle mr-2"
                    />
                </v-list-item-icon>
                <v-list-item-title class="ml-4">
                    {{ menuItem.name || menuItem.text }}
                </v-list-item-title>
            </v-list-item> 
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        name: 'NavigationItemMenu',
        props: {
            data: {
                type: Object,
                required: true
            },
            navigationItem: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            model: null,
            showMenu: false,
            hotspotImg: require('@/assets/images/sidebar-color-pin.png')
        }),
        computed: {
            itemList() {
                return this.$props.navigationItem.submenu ? this.$props.navigationItem.submenu : this.$props.navigationItem.hotspots;
            }
        },
        mounted() {
            this.model = this.itemList.findIndex(item => item.active);
        },
        methods: {
            selectItem(item, subitem) {
                this.$emit('selectNavigationItemMenu', item, subitem);
                switch (this.$props.data.type) {
                    case 'hotspot':
                    case 'plot':
                        this.$emit('selectNavigationItemMenu',item, subitem);
                    break;
                    case 'models':
                        this.$emit('selectNavigationItemMenu', subitem);
                    break;
                    default:
                        break;
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/layout/alternative/layout/components/NavigationItemMenu.vue